import React from "react";

const AddressCard = ({ title, address }) => {
  if (!address) return null;

  return (
    <div className="p-2">
      <h6 className="heading_custom">{title}</h6>
      <p>
        {address.fullName} <br />
        {address.address1}, {address.state}, {address.zipCode} <br />
        {address.country} <br />
        <i className="fa-solid fa-phone"></i> {address.mobile}
      </p>
    </div>
  );
};

export default AddressCard;
